import { GroupManagementState, IDevicesGroupsState, IGroupsActions, INavigation } from './types';

const getters = {
  getGroups(state: GroupManagementState) {
    return state.groups;
  },
  getGroupsState(state: GroupManagementState): IDevicesGroupsState {
    return state.groupsComponentsState;
  },
  getNavigationConfiguration(state: GroupManagementState): INavigation {
    return state.navigation;
  },
  getTotal(state: GroupManagementState) : number {
    return state.total;
  },
  getErrorMessage(state: GroupManagementState) : string {
    return state.errorMessage;
  },
  getIsLastGroupPage(state: GroupManagementState) : boolean {
    return state.navigation.isLastGroupPage;
  },
  getUserSelectionGroups(state: GroupManagementState): string[] {
    return state.userSelection.groups;
  },
  getUserSelectionGroupsIds(state: GroupManagementState): number[] {
    return state.userSelection.groups.map(id => Number(id));
  },
  getNumberUserSelectionGroups(state: GroupManagementState): number {
    return state.userSelection.groups.length;
  },
  getUserSelectionGroupsActionsNames(state: GroupManagementState): string[] {
    return Object.values(state.userSelection.actions).map(x => x.label);
  },
  getUserSelectionGroupsActions(state: GroupManagementState): { [key: string]: IGroupsActions } {
    return state.userSelection.actions;
  }
};
export default getters;
